import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DxFormComponent} from "devextreme-angular";
import {DxiItemComponent} from "devextreme-angular/ui/nested";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";
import {TimeOffDto, TimeOffStatus} from "@services";
import EnumUtils from "../../../../shared/enum-utils";

@Component({
    selector: 'app-time-off-filter-panel',
    imports: [
        DxFormComponent,
        DxiItemComponent,
        FilterPanelComponent
    ],
    templateUrl: './time-off-filter-panel.component.html'
})
export class TimeOffFilterPanelComponent {
    @Input() filterModel: TimeOffDto;
    filterModelName = (name: keyof TimeOffDto): string => name;
    statusOptions = EnumUtils.getEnumOptions(TimeOffStatus);

    @Input() isOpened: boolean;
    @Output() isOpenedChange = new EventEmitter<boolean>();
    @Output() onSearch = new EventEmitter<void>();
    @Output() onClear = new EventEmitter<void>();
    @Output() pinnedChange = new EventEmitter<void>();

    protected filterPanelOpenedChanged(value: boolean) {
        this.isOpened = value;
        this.isOpenedChange.emit(value);
    }
}
